// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#inv-copy-to {\n  max-width: none;\n  margin: 0px 0px -10px;\n}\n#inv-copy-to .k-grid {\n  margin: 0px 0px 10px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
